
import { Components, Theme } from "@mui/material";

export default {
  MuiList: {
    styleOverrides: {
      root: {
        paddingTop: 0,
        paddingBottom: 0,
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        padding: "7px 0"
      }
    }
  }
} as Components<Omit<Theme, "components">>;